<template>
	<form class="form" @submit.prevent="submit" novalidate>
		<ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>

		<fieldset class="form__group">
			<legend>The Opportunity</legend>
			<div class="form__group">
				<div class="toggle-group">
					<input
                        id="is-mandated"
                        name="mandated"
                        class="toggle"
                        type="radio"
                        :value="true"
                        v-model="formData.mandated"
                        v-validate
                        required
                    />
					<label for="is-mandated" class="toggle">Yes</label>
					<input
                        id="is-not-mandated"
                        name="mandated"
                        class="toggle"
                        type="radio"
                        :value="false"
                        v-model="formData.mandated"
                        v-validate
                        required
                    />
					<label for="is-not-mandated" class="toggle">No</label>
				</div>
				<label class="form__label">Mandated or Non-Mandated?</label>
				<div class="form__validation">{{ errors.first('mandated') }}</div>
			</div>
			<FormControlDealType
                v-model="formData.dealType"
                name="deal type"
                v-validate="'required'"
            />
			<div class="form__group">
				<div class="toggle-group">
					<input
                        id="is-urgent"
                        name="urgent"
                        class="toggle"
                        type="radio"
                        :value="true"
                        v-model="formData.urgent"
                        v-validate
                        required
                    />
					<label for="is-urgent" class="toggle">Yes</label>
					<input
                        id="is-not-urgent"
                        name="urgent"
                        class="toggle"
                        type="radio"
                        :value="false"
                        v-model="formData.urgent"
                        v-validate
                        required
                    />
					<label for="is-not-urgent" class="toggle">No</label>
				</div>
				<label class="form__label">Urgent</label>
				<div class="form__validation">{{ errors.first('urgent') }}</div>
			</div>
			<FormControlDatepicker
                name="respondBy"
                v-model="formData.respondBy"
                label="Response required by"
                v-if="formData.urgent"
                v-validate="'required'"
            />
			<div class="form__group">
				<FormControlSector
                    name="sector"
                    v-model="formData.sectors"
                    v-validate="'required'"
                    value-format="object"
                    :multiple="true"
                />
			</div>
            <div class="form__group" v-if="formData.sectors">
                <div class="form__group">
                    <select name="primary-sector" v-model="formData.primarySector" class="form__control">
                        <option
                            v-for="sector in formData.sectors"
                            :id='`primary-sector-${sector.id}`'
                            :value="sector.id"
                        >
                            {{ sector.name }}
                        </option>
                    </select>
                    <label for="filter" class="form__label">Main Category:</label>
                </div>
            </div>
			<div class="form__group form__group--submit">
				<button class="btn" @click.prevent="back" v-wait:disabled='"submit"'>Back</button>
				<button class="btn btn--primary" v-wait:disabled='"submit"'>Save &amp; Continue</button>
			</div>
		</fieldset>
	</form>
</template>

<script>
	import OpportunityFormStep from './OpportunityFormStep';
	import ValidationAlert from '../../ValidationAlert';
	import FormControlDealType from '../../Form/Control/FormControlDealType';
	import FormControlSector from '../../Form/Control/FormControlSector';
	import FormControlDatepicker from '../../Form/Control/FormControlDatepicker';

	export default {
		name: 'OpportunityFormStep3',
		mixins: [OpportunityFormStep],
		components: {
			FormControlDatepicker,
			FormControlDealType,
			FormControlSector,
			ValidationAlert,
		},
		data() {
			return {
				formData: {
					sectors: [],
                    primarySector: null,
					mandated: null,
					dealType: null,
					urgent: null,
					respondBy: null,
				}
			}
		},
	}
</script>
